module.exports = __webpack_public_path__ + "img/bd89f9f.svg";